import React from "react";
import "./getting-started-content.component.scss";
import appConfig from "../../config/app.config";
import ContentProductPage from "../getting-started-content/content-product-page/content-product-page.component"
import ContentHomePage from "../getting-started-content/content-home-page/content-home-page.component"
import ContentSignIn from "../getting-started-content/content-sign-in/content-sign-in.component"
import ContentApiCardSection from "../getting-started-content/content-api-card-section/content-api-card-section.component";
import ContentAccountAuthorization from "../getting-started-content/content-account-authorization/content-account-authorization.component"
import ContentUsingOtherApi from "../getting-started-content/content-using-other-api/content-using-other-api.component"
import ContentUserProfilePage from "../getting-started-content/content-user-profile-page/content-user-profile-page.component"
import ContentSignOut from "../getting-started-content/content-sign-out/content-sign-out.component"
import ContentForgotPassword from "../getting-started-content/content-forgot-password/content-forgot-password.component"
import ContentPointToRemember from "../getting-started-content/content-point-to-remember/content-point-to-remember.component"
import { USER_MANUAL } from "../../constants/user-manual.constants"


const { HOME_PAGE, SIGN_IN, PRODUCT_PAGE, API_CARD_SECTION, ACCOUNT_AUTHORIZATION, USING_OTHER_API, USER_PROFILE_PAGE, SIGN_OUT, FORGOT_PASSWORD,POINT_TO_REMEMBER } = USER_MANUAL
const staticAssetsUrl = appConfig.staticAssetsUrl;

const GettingStartedContent = ({ activeSummary, setActiveSummary }) => {
    return (
        <div className="getting-started-content">
            {activeSummary === HOME_PAGE && (
                <ContentHomePage />
            )}

            {activeSummary === SIGN_IN && (
                <ContentSignIn />
            )}

            {activeSummary === PRODUCT_PAGE && (
                <ContentProductPage />
            )}


            {activeSummary === API_CARD_SECTION && (
                <ContentApiCardSection />
            )}


            {activeSummary === ACCOUNT_AUTHORIZATION && (
                <ContentAccountAuthorization />
            )}


            {activeSummary === USING_OTHER_API && (
                <ContentUsingOtherApi />

            )}


            {activeSummary === USER_PROFILE_PAGE && (
                <ContentUserProfilePage />
            )}


            {activeSummary === SIGN_OUT && (
                <ContentSignOut />
            )}


            {activeSummary === FORGOT_PASSWORD && (
                <ContentForgotPassword />

            )}

            {activeSummary === POINT_TO_REMEMBER && (
                <ContentPointToRemember />
            )}
        </div>
    )
}

export default GettingStartedContent